import { render, staticRenderFns } from "./ComprobacionAmexRechazar.vue?vue&type=template&id=c7201d96&scoped=true&"
import script from "./ComprobacionAmexRechazar.vue?vue&type=script&lang=js&"
export * from "./ComprobacionAmexRechazar.vue?vue&type=script&lang=js&"
import style0 from "./ComprobacionAmexRechazar.vue?vue&type=style&index=0&id=c7201d96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7201d96",
  null
  
)

component.options.__file = "ComprobacionAmexRechazar.vue"
export default component.exports